<template>
  <div>
    <b-form @submit.prevent="validateForm()" data-vv-scope="formulario">
      <b-row>
        <b-col :class="action == 'create' ? 'col-md-12' : 'col-md-2'">
          <b-form-group>
            <label for="codigo">Código</label>
            <b-form-input
              name="codigo"
              id="rol_codigo"
              v-model="selectedRol.codigo"
              data-vv-as=" "
              v-validate="'required'"
            />
            <div
              class="text-danger small"
              v-text="errors.first('formulario.codigo')"
            />
          </b-form-group>
        </b-col>
        <b-col :class="action == 'create' ? 'col-md-12' : 'col-md-2'">
          <b-form-group>
            <label for="rol">Rol</label>
            <b-form-input
              name="rol"
              id="rol_name"
              v-model="selectedRol.rol"
              data-vv-as=" "
              v-validate="'required'"
            />
            <div
              class="text-danger small"
              v-text="errors.first('formulario.rol')"
            />
          </b-form-group>
        </b-col>
        <b-col :class="action == 'create' ? 'col-md-12' : 'col-md-8'">
          <b-form-group>
            <label for="descripcion">Descripción</label>
            <b-form-input
              name="descripcion"
              id="rol_description"
              v-model="selectedRol.descripcion"
              data-vv-as=" "
              v-validate="'required'"
            />
            <div
              class="text-danger small"
              v-text="errors.first('formulario.descripcion')"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group class="text-center">
            <b-button variant="primary" type="submit">
              <i class="fa fa-floppy-o"></i>
              Guardar  
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "modalRol",
  props: ['action'],
  data() {
    return {};
  },
  methods: {
    async validateForm() {
      this.$validator.validateAll("formulario").then(async (result) => {
        if (result) {
          if (this.action != 'update') {
            await this.saveRol();
            await this.getRoles();
            this.resetSelectedRol();
          } else {
            await this.updateRol(this.selectedRol.id);
          }
        }
      });
    },
    beforeDestroy() {
      this.resetSelectedRol();
    },
    ...mapActions("rolesPermissions", ["saveRol","getRoles","updateRol"]),
    ...mapMutations("rolesPermissions", ["resetSelectedRol"]),
  },
  computed: {
    ...mapState("rolesPermissions", ["selectedRol"]),
  },
};
</script>